import { Emitter } from 'nanoevents';
import { DataConvertError } from './local-edit-data-converter.interface';
import { SaveType } from '@tencent/mega-sdk-protocols';

export const enum LocalEditEvents {
    /** 本地编辑服务初始化 */
    LocalEditServiceInit,
    /** 开始发起首次接口请求 */
    LoadDocumentStart,

    /** 首帧导入成功 */
    LoadDocumentHeadSuccess,
    /** 接收到单个分片导入 */
    LoadDocumentChunkReceived,
    /** 分片导入成功 */
    LoadDocumentAllChunksSuccess,
    /** 本地文档加载失败 */
    LoadDocumentError,
    /** 本地文档需要密码 */
    LoadDocumentPasswordRequired,
    /** 本地文档密码不合法 */
    LoadDocumentPasswordInvalid,
    /** 本地文档 native 控制输入密码逻辑 */
    LoadDocumentUseNativePassword,

    /** SlideApp 初始化成功 */
    SlideAppInitSuccess,
    /** SlideApp 数据损坏 */
    SlideAppDataError,

    /** 导出文档开始 */
    SaveDocumentBegin,
    /** 导出文档成功 */
    SaveDocumentSuccess,
    /** 导出文档失败 */
    SaveDocumentError,

    /** 文档信息变更(另存为成功) */
    DocumentInfoChanged,
    /** 文档被编辑 */
    DocumentChanged,
}

/**
 * 本地编辑事件
 */
export interface ILocalEditEventMap {
    /** 本地编辑服务初始化 */
    [LocalEditEvents.LocalEditServiceInit]: () => void;
    /** 发起首帧数据接口请求 */
    [LocalEditEvents.LoadDocumentStart]: () => void;
    /** 首帧导入成功 */
    [LocalEditEvents.LoadDocumentHeadSuccess]: () => void;
    /** 接收到单个分片导入 */
    [LocalEditEvents.LoadDocumentChunkReceived]: (chunkIndex: number, chunkCount: number) => void;
    /** 分片导入成功 */
    [LocalEditEvents.LoadDocumentAllChunksSuccess]: () => void;
    /** 本地文档加载失败 */
    [LocalEditEvents.LoadDocumentError]: (err: DataConvertError) => void;
    /** 本地文档需要密码 */
    [LocalEditEvents.LoadDocumentPasswordRequired]: () => void;
    /** 本地文档密码不合法 */
    [LocalEditEvents.LoadDocumentPasswordInvalid]: () => void;
    /** 本地文档 native 控制输入密码逻辑 */
    [LocalEditEvents.LoadDocumentUseNativePassword]: () => void;

    /** SlideApp 初始化成功 */
    [LocalEditEvents.SlideAppInitSuccess]: () => void;
    /** SlideApp 初始化失败 */
    [LocalEditEvents.SlideAppDataError]: (err: Error) => void;

    /** 导出文档开始 */
    [LocalEditEvents.SaveDocumentBegin]: (traceKey: string) => void;
    /** 导出文档成功 */
    [LocalEditEvents.SaveDocumentSuccess]: (saveType: SaveType, traceKey: string, beginAt: number) => void;
    /** 导出文档失败 */
    [LocalEditEvents.SaveDocumentError]: (err: DataConvertError, saveType: SaveType, traceKey: string) => void;
    /** 文档信息变更 */
    [LocalEditEvents.DocumentInfoChanged]: (newPath: string, newTitle: string, newGlobalPadId: string) => void;
    /** 文档被编辑 */
    [LocalEditEvents.DocumentChanged]: () => void;
}

export type ILocalEditEvents = Emitter<ILocalEditEventMap>;
